module.exports = __webpack_public_path__ + "static/media/mascot-mark-white.862c862c.svg";